<template>
  <div  class="systemHelp">
    <div class="top">
      <van-icon size="22px" name="arrow-left" @click="back" />
      <span class="title">{{ $t('append_field.system_help')}}</span>
    </div>
      <div class="content">
        <div class="title"> {{$t('append_field.Formatspecification') }}</div>
          <van-cell>
            <div class="van-cell__title">
              <span class="van-cell__text" >{{ $t('append_field.fileFormat')}} ：{{ 'pdf、xls、xlsx' }}</span>

            </div>
          </van-cell>
        <van-cell>
          <div class="van-cell__title">
            <span class="van-cell__text" >{{ $t('append_field.aliyun_storage_support')}} ：{{ '.pdf、.xls、.xlsx、.ppt、.pptx、.doc、.docx' }} </span>
          </div>
        </van-cell>
        <van-cell>
          <div class="van-cell__title">
            <span class="van-cell__text">{{ $t('append_field.imgFormat')}} ： {{'jpg、jpeg、png、gif'}}</span>
          </div>
        </van-cell>
        <van-cell>
          <div class="van-cell__title">
            <span class="van-cell__text">{{ $t('append_field.videoFormat')}} ： {{'flv、avi、mp4、wmv、mrv、mpg、mkv、mov、mpeg、swf、ts'}}</span>
          </div>
        </van-cell>
        <van-cell>
          <div class="van-cell__title">
            <span class="van-cell__text">{{ $t('append_field.audioFormat')}} ： {{'aac、flac、ogg、mp3、wav、ape、wma'}}</span>
          </div>
        </van-cell>
        <div class="title">{{  $t('append_field.system_version') }}</div>
        <van-cell>
          <div class="van-cell__title">
            <span class="van-cell__text">{{ $t('append_field.system_version') }} ：{{ sysVersion() }}</span>
          </div>
        </van-cell>
        <van-cell>
          <div class="van-cell__title">
            <span class="van-cell__text">{{ $t('append_field.updated') }} ：{{ updated() }}</span>
          </div>
        </van-cell>
        <van-cell>
          <div class="van-cell__title">
            <span class="van-cell__text">{{ $t('append_field.updateInfo') }}:
            </span>
            <p v-html="$t('append_field.details')"></p>
          </div>
        </van-cell>
      </div>
  </div>

</template>

<script>
import {environment, sysVersion, updated} from "../assets/js/user_environment";
export default {

  methods: {
    environment() {
      return environment
    },
    sysVersion() {
      return sysVersion
    },
    updated() {
      return updated
    },

    back() {
      this.$router.push('/my')
    },

  }
}
</script>

<style scoped lang="scss">
.systemHelp {
  height: 100% !important;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 55;
  background: #ffffff;
  display: flex;
  flex-direction: column;
}

.systemHelp .top {
  padding: 18px 10px;
  display: flex;
  align-items: center; /* 垂直居中对齐 */
  justify-content: center; /* 水平居中对齐 */
  position: sticky; /* 使用 sticky 固定位置 */
  top: 0; /* 固定在顶部 */
  border-bottom: #8c8c8c 1px solid;
  background: #ffffff; /* 确保背景色与父元素一致 */
  z-index: 1; /* 确保在内容上方 */

  .van-icon {
    position: absolute; /* 绝对定位 */
    left: 10px; /* 根据需要调整左边距 */
  }
  .title {
    font-size: 18px;
    display: inline-block; /* 使元素成为行内块级元素 */
  }
}

.systemHelp .content {
  display: flex;
  flex-direction: column;

  .title {
    background-color: #f2f2f2;
    padding: 10px;
    font-weight: bolder;
  }
}

</style>